<template>
  <div id="app">
    <div id="nav">
    </div>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch:{
    $route(){
      window.scrollTo(0,0);
    }
  },
  created () {
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue